module.exports = __webpack_public_path__ + "static/ClickedPassedAway-3723879ec9b70d21f86f3708730e9354.png";